import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customerBasicInfo" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerBasicInfo',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getDept = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  const deptOptions = deptList.map((item: any) => {
    return { title: item.name, value: item.name }
  })
  const deptItem = searchFormConfig.formItems.find((item) => item.field === 'deptName')
  deptItem!.options = deptOptions
}
getDept()

const getCompanyList = async () => {
  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const corpItem = searchFormConfig.formItems.find((item) => item.field === 'corpName')
  corpItem!.options = corpData.map((item: any) => {
    return { title: item.name, value: item.name }
  })
}
getCompanyList()

const queryParam = {
  pageNo: 1,
  pageSize: 10
}

store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return { ...queryParam }
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      labelWidth: "100px"
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerBasicInfo",
      pageUrl: "/main/customer-basic-info/queryList",
      filterRules: [],
      usePost: true
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})